export const environment = {
  production: true,
  ildatoArticoliDpi: 'https://articoli-monza-protezione-civile.ildato.it/',
  nomeApp: 'Gestione Articoli',
  sottotitolo: 'Monza Protezione Civile',
  altCaption: 'Ildato-ArticoliDpi',
  frontendVersionApiKey: '8aedb1f0-6874-47d5-bb58-cd557354d0a9',
  msClientId: '79ed66db-2977-40f3-b5e8-52f0bd5f2ae9',
  msAuthority:
    'https://login.microsoftonline.com/21fe3236-12b5-4832-8d2a-a402599a851c/v2.0',
  redirectUri: 'https://articoli-monza-protezione-civile.ildato.it/login-entraid',
  accessEndpoint: 'https://articoli-monza-protezione-civile.ildato.it/api',
  frontChannelUrl: 'https://articoli-monza-protezione-civile.ildato.it/login-form',
  authBase: true,
  authAvanzato: true,
};
